import {Component, OnInit, ViewChild} from '@angular/core';
import {CuentasService, DialogsService, NavigationService, SpinnerService} from '../../../../services';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {trimValidString} from '../../../../utils/validators/CustomValidators';
import {UsuarioAgro} from '../usuarios.component';
import {ChipsSelectorComponent, ColaboradorAutocompleteComponent} from '../../../common';
import {RolesAutocompleteComponent} from '../../../common';
import {ActivatedRoute, Router} from '@angular/router';
import {PATH_CUENTAS} from '../../../../navigation/navigation.module';
import {Location} from '@angular/common';
import {Subscription} from 'rxjs/Subscription';
import {MdSnackBar} from '@angular/material';

@Component({
  selector: 'app-edit-usuario',
  templateUrl: './edit-usuario.component.html',
  styleUrls: ['./edit-usuario.component.scss']
})
export class EditUsuarioComponent implements OnInit {

  form: FormGroup = null;

  @ViewChild(ChipsSelectorComponent) chips: ChipsSelectorComponent;
  // recordemos que SOLO EN ESTA SECCION DEL SISTEMA llamamos a los roles, acopios.
  @ViewChild(RolesAutocompleteComponent) acopiosAutocomplete: RolesAutocompleteComponent;
  @ViewChild(ColaboradorAutocompleteComponent) colaboradoresAutocomplete: ColaboradorAutocompleteComponent;

  usernamesDuplicados = [];

  usuario: UsuarioAgro = null;
  roles: number[] = [];
  oficialesCuenta = [];

  estados = [
    {Id: 0, Nombre: 'INACTIVE', Label: 'Inactivo'},
    {Id: 1, Nombre: 'ACTIVE', Label: 'Activo'},
    // {Id: 3, Nombre: 'UNKNOWN', Label: 'Desconocido'}
  ];

  allEstados = [];

  rolesList: {ID: number, ItemLabel: string}[] = [
    {ID: 1, ItemLabel: 'Solo Lectura'},
    // {ID: 2, ItemLabel: 'Colaborador AGD'},
    // {ID: 4, ItemLabel: 'Administrador'},
    {ID: 5, ItemLabel: 'Usuario Agripago'},
  ];

  agripagoExists = false;
  sub: Subscription[] = [];
  constructor(
    private navigationService: NavigationService,
    private fb: FormBuilder,
    private cuentasService: CuentasService,
    private route: ActivatedRoute,
    private location: Location,
    private router: Router,
    private spinnerService: SpinnerService,
    private dialogsService: DialogsService,
    private snackBar: MdSnackBar,
  ) {
    this.route.params.subscribe(params => {
      const id = this.route.snapshot.params['id'];
      this.cuentasService.agroGetUser(id).subscribe(x => {
        this.usuario = x as UsuarioAgro;
        this.setupForm();
      });
    });
    cuentasService.agroSetupRoles()
    cuentasService.agroGetEstados().subscribe(x => {
      this.allEstados = x;
    });
    cuentasService.usuariosRoles$.subscribe(x => {
      this.rolesList = x.filter(y => y.Id === 1 || y.Id === 5).map(y => ({ID: y.Id, ItemLabel: y.Nombre}))
    })
  }

  ngOnInit() { }

  setupForm(): void {
    const cuits: FormGroup[] = [];
    this.usuario.Cuits.forEach(x => {
      const group = this.fb.group({
        cuit: [x.Cuit, [Validators.required, Validators.minLength(11), Validators.maxLength(11), Validators.pattern(new RegExp('^([0-9])+$'))]],
        razon: new FormControl({value: x.RazonSocial.length ? x.RazonSocial : '-' , disabled: true}),
        agriPago: [x.AsociadoAgripago]
      });
      this.sub.push(
        group.get('cuit').valueChanges.debounceTime(750).subscribe(value => {
          if (value.toString().length && value.toString().length === 11) {
            const sub = this.cuentasService.agroGetRazonSocial(value).subscribe(res => {
              if (res.ApeNom !== null) {
                group.get('razon').setValue(res.ApeNom.toString());
              }
              sub.unsubscribe();
            }, err => sub.unsubscribe());
          }
        })
      );
      cuits.push(group);
    });
    this.roles = this.usuario.Roles.map(x => x.Id);
    this.checkAgripagoExists();

    this.form = this.fb.group({
      usuario: [this.usuario.User, [Validators.required, Validators.minLength(5), Validators.pattern(new RegExp('^([0-9]|[a-z]|[A-Z])+$'))]],
      nombre: [this.usuario.Nombre, [Validators.required, trimValidString(), Validators.pattern(new RegExp('^([a-z]|[áéíóúñ]|\\s)+$', 'i'))]],
      apellido: [this.usuario.Apellido, [Validators.required, trimValidString(), Validators.pattern(new RegExp('^([a-z]|[áéíóúñ]|\\s)+$', 'i'))]],
      cuits: this.fb.array(cuits, atLeastOneAndOneTrueValidator(this.agripagoExists, 'agriPago')),
      observaciones: [this.usuario.Observaciones !== null ? this.usuario.Observaciones : ''],
      acopios: [this.usuario.Acopios && this.usuario.Acopios.length ? this.usuario.Acopios.map(x => x.Id.toString()).join(',') : '', [Validators.required]],
      roles: ['', [Validators.required]],
      mail: new FormControl({value: this.usuario.Mail, disabled: true}),
      // el teléfono solo es obligatorio si el rol agripago existe
      telefono: [this.usuario.Telefono != null ? this.usuario.Telefono : '', this.agripagoExists ? [Validators.required, anyMinMaxLength(10, 10)] : [anyMinMaxLength(10, 10)]],
      estado: new FormControl({value: this.usuario.Estado, disabled: this.usuario.Estado === 'PENDING_OF_APPROVAL'}),
    });
    this.oficialesCuenta = this.usuario.OficialesDeCuenta.map(x => {return {UserFullName: x.Nombre, UserId: x.Id, canViewProduct: true}});
    this.rolesCtrl.setValue(this.roles.join(','));
    this.initializeOficialesCuentaSelect();
    /* En muchas ocasiones los cuits que vienen del back estan sin la razon social, con esto disparamos el subscriber para
       recuperar los cuits y forzamos una busqueda de razon social*/
    this.cuitsForms.controls.forEach(controls => {
      controls.get('cuit').updateValueAndValidity({ onlySelf: false, emitEvent: true });
    });
  }

  initializeRolesSelect() {
    this.chips.optionsChange(this.rolesList, this.roles);
  }


  initializeOficialesCuentaSelect() {
    if (this.colaboradoresAutocomplete && this.oficialesCuenta.length) {
      this.colaboradoresAutocomplete.selectedColaboradores = this.oficialesCuenta;
    }
  }

  rolesChanged(e) {
    this.roles = e.SelectedIds;
    this.rolesCtrl.setValue(this.roles.join(','));

    // aqui Hardcodeamos el ID de AGRIPAGO para una verificacion posterior, puede cambiar a una verificacion de string en el futuro
    this.checkAgripagoExists();
    this.cuitsForms.setValidators(atLeastOneAndOneTrueValidator(this.agripagoExists, 'agriPago'));
    this.cuitsForms.updateValueAndValidity();
  }

  crearCuit(): void {
    const group = this.fb.group({
      cuit: ['', [Validators.required, Validators.minLength(11), Validators.maxLength(11), Validators.pattern(new RegExp('^([0-9])+$'))]],
      razon: new FormControl({value: '-', disabled: true}),
      agriPago: [false]
    });
    this.sub.push(
      group.get('cuit').valueChanges.debounceTime(750).subscribe(value => {
        if (value.toString().length && value.toString().length === 11) {
          const sub = this.cuentasService.agroGetRazonSocial(value).subscribe(res => {
            if (res.ApeNom !== null) {
              group.get('razon').setValue(res.ApeNom.toString());
            }
            sub.unsubscribe();
          }, err => sub.unsubscribe());
        }
      })
    );
    this.cuitsForms.push(group);


  }

  getAcopios(): number[] {
    return this.usuario.Acopios.map(x => x.Id);
  }

  onAcopiosChanged(): void {
    this.acopiosCtrl.setValue(this.acopiosAutocomplete.selectedRoles.map(x => x.Id).join(','));
  }

  navigateBack() {
    if (this.navigationService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/' + PATH_CUENTAS + '/usuarios');
    }
  }

  checkAgripagoExists() {
    this.agripagoExists = this.roles.indexOf(5) > -1;
    if (!this.agripagoExists && this.form !== null) {
      this.cuitsForms.controls.forEach(x => {
        x.get('agriPago').setValue(false);
      })
    }
    if (this.form !== null) {
      this.telefonoCtrl.setValidators(this.agripagoExists ? [Validators.required, anyMinMaxLength(10, 10)] : [anyMinMaxLength(10, 10)]);
      this.telefonoCtrl.updateValueAndValidity();
    }
  }

  onSubmit(): void {
    for (let i in this.form.controls) {
      this.form.controls[i].markAsTouched();
    }
    this.form.updateValueAndValidity();
    if (this.form.invalid) {
      this.snackBar.open('Algunos campos poseen errores. Por favor verfíquelos antes de continuar.', '', {
        duration: 4000,
      });
      return;
    }
    this.dialogsService.confirm(
      '¿Está seguro que desea guardar los cambios?',
      '',
      'ACEPTAR',
      'CANCELAR'
    ).subscribe(res => {
      if (res) {
        const payload = {
          Usuario: this.usuarioCtrl.value,
          Nombre: this.nombreCtrl.value.toString().trim(),
          Apellido: this.apellidoCtrl.value.toString().trim(),
          Telefono: this.telefonoCtrl.value.toString(),
          Observaciones: this.observacionesCtrl.value,
          Estado: this.allEstados.find(x => x.Nombre === this.estadoCtrl.value).Id,
          Cuits: this.cuitsForms.controls.map(x => {
            return {Cuit: x.get('cuit').value, Asociado_Agripago: x.get('agriPago').value ? 1 : 0}
          }),
          Roles: this.roles,
          OficialesDeCuenta: this.colaboradoresAutocomplete.selectedColaboradores.map(x => x.UserId),
          Acopios: this.acopiosAutocomplete.selectedRoles.map(x => x.Id),
          UserId: this.usuario.ID
        }
        this.spinnerService.setShowFlag(true);
        this.cuentasService.agroEdit(payload).subscribe(x => {
          this.spinnerService.setShowFlag(false);
          if (x) {
            if (x === 'DUPLICATE-USERNAME') {
              // si el nombre de usuario esta duplicado, creamos un validador para el control de usuarios
              // y almacenamos el valor en un array que ira creciendo con cada intento fallido (en esta edicion solamente)
              // para que en caso de volver a colocar el mismo usuario u otro duplicado, no se verifique innecesariamente si no
              // que los valores repetidos figuraran como erroneos
              this.usernamesDuplicados.push(this.usuarioCtrl.value);
              // debemos volver a setear TODOS los validadores
              this.usuarioCtrl.setValidators([
                Validators.required,
                Validators.minLength(5),
                Validators.pattern(new RegExp('^([0-9]|[a-z]|[A-Z])+$')),
                // ahora seteamos el calidador nuevo con los nuevos valores
                notInArray(this.usernamesDuplicados)
              ]);
              this.usuarioCtrl.updateValueAndValidity({emitEvent: true});
            } else {
              this.snackBar.open('Usuario editado satisfactoriamente', null, {
                duration: 2000,
              });
              this.router.navigateByUrl('/' + PATH_CUENTAS + '/usuarios');
            }
          }
        }, err => {
          this.spinnerService.setShowFlag(false);
          this.snackBar.open('Se ha producido un error al procesar la solicitud.', '', {
            duration: 2000,
          });
        });
      }
    });
  }

  get nombreCtrl(): AbstractControl {
    return this.form.get('nombre');
  }

  get apellidoCtrl(): AbstractControl {
    return this.form.get('apellido');
  }

  get observacionesCtrl(): AbstractControl {
    return this.form.get('observaciones');
  }

  get cuitsForms(): FormArray {
    return this.form.get('cuits') as FormArray;
  }

  get rolesCtrl(): AbstractControl {
    return this.form.get('roles');
  }

  get usuarioCtrl(): AbstractControl {
    return this.form.get('usuario');
  }

  get mailCtrl(): AbstractControl {
    return this.form.get('mail');
  }

  get telefonoCtrl(): AbstractControl {
    return this.form.get('telefono');
  }

  get estadoCtrl(): AbstractControl {
    return this.form.get('estado');
  }

  get acopiosCtrl(): AbstractControl {
    return this.form.get('acopios');
  }

}

function atLeastOneAndOneTrueValidator(checkAgripago: boolean, subControlName: string): ValidatorFn {
  return function validate(formArray: FormArray) {
    if (!formArray.controls.length) {
      return {required: true};
    }

    if (checkAgripago) {
      let invalid = true;
      formArray.controls.forEach(ctrl => {
        if (ctrl.get(subControlName) !== null && ctrl.get(subControlName).value) {
          invalid = false;
        }
      });
      if (invalid) {
        return {cuitAgripago: true};
      }
    }
    return null;
  };
}

function anyMinMaxLength(min: number, max: number): ValidatorFn {
  return function validate(control: AbstractControl) {
    if (control.value !== null && control.value !== undefined) {
      const len = control.value.toString().length;
      return (len >= min && len <= max) || len === 0 ? null : {anyMinMax: true};
    }
    return null;
  };
}

function notInArray(list: any[]): ValidatorFn {
  return function validate(control: AbstractControl) {
    return list.indexOf(control.value) === -1 ? null : {duplicated: true};
  };
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/usuarios/edit-usuario/edit-usuario.component.ts